import * as React from 'react';
import Box from '@mui/material/Box';
import { Switch } from '@mui/material';
import Typography from '@mui/material/Typography';

type TimelineCalendarAdvancedToggleProps = {
    isAdvancedMode: boolean;
    onChangeAdvancedMode: () => void;
    advancedModeTitle: string;
};

function TimelineCalendarAdvancedToggle({
    isAdvancedMode,
    onChangeAdvancedMode,
    advancedModeTitle
}: TimelineCalendarAdvancedToggleProps) {
    return (
        <Box display={'flex'} alignItems={'center'} sx={{ width: '100%' }} aria-label='advanced-checkbox'>
            <Switch checked={isAdvancedMode} onChange={onChangeAdvancedMode} />
            <Typography
                sx={{
                    fontWeight: 700,
                    paddingRight: '7px',
                    fontSize: '15px'
                }}
            >
                {advancedModeTitle}
            </Typography>
        </Box>
    );
}

export default TimelineCalendarAdvancedToggle;
